<div class="dialog-user-interview">
  <div class="dialog-user-interview__close-wrapper">
    <button
      class="dialog-user-interview__close-btn"
      type="button"
      (click)="cancel()"
      [attr.aria-label]="'Global.Action.Cancel' | translate"
    >
      &times;
    </button>
  </div>

  <div class="dialog-user-interview__body">
    <h3 class="dialog-user-interview__title">
      {{ "UserInterview.Modal.Title" | translate }}
    </h3>

    @if (success()) {
      <p class="dialog-user-interview__text">
        {{ "UserInterview.Modal.RegistrationSuccess" | translate }}
      </p>
    } @else if (failure()) {
      <div>{{ "UserInterview.Modal.RegistrationFailed" | translate }}</div>
    } @else {
      <p class="dialog-user-interview__text">
        {{ "UserInterview.Modal.Body" | translate }}
      </p>

      <p class="dialog-user-interview__data-notice">
        {{ "UserInterview.Modal.DataNotice" | translate }}
      </p>

      <textarea
        class="dialog-user-interview__textarea"
        [(ngModel)]="message"
        [placeholder]="'UserInterview.Modal.Placeholder' | translate"
        rows="4"
      ></textarea>

      <div class="dialog-user-interview__checkbox-wrapper">
        <div class="dialog-user-interview__checkbox">
          <input
            type="checkbox"
            id="interview-confirm"
            [ngModel]="confirmed()"
            (ngModelChange)="confirmed.set($event)"
          />
          <label for="interview-confirm">
            {{ "UserInterview.Modal.Confirm" | translate }}
          </label>
        </div>
      </div>
    }
  </div>

  <div class="dialog-user-interview__footer">
    @if (success()) {
      <button class="button button--primary" type="button" (click)="cancel()">
        {{ "Global.Action.Close" | translate }}
      </button>
    } @else {
      <button class="button button--secondary" type="button" (click)="cancel()">
        {{ "Global.Action.Cancel" | translate }}
      </button>
    }

    @if (idle() || sending()) {
      <safe-button
        class="button button--primary"
        type="button"
        [class.button--disabled]="!confirmed()"
        [disabled]="!confirmed()"
        [loading]="sending()"
        (clicked)="send()"
      >
        {{ "UserInterview.Modal.Send" | translate }}
      </safe-button>
    }

    @if (failure()) {
      <button class="button button--primary" type="button" (click)="reset()">
        {{ "Global.Action.TryAgain" | translate }}
      </button>
    }
  </div>
</div>
